module.exports = __webpack_public_path__ + "static/ss19.aeb48af1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss19.jpg
// module id = 1196
// module chunks = 81679748166845